import * as cfe from 'ego-cfe';
import React from 'react';

import useThreadRoot from './hooks/useThreadRoot';
import SourceTraceIcon from './icon/SourceTraceIcon';
import Button from './lib/Button';
import SectionHeaderTab from './SectionHeaderTab';
import Thread, { ThreadMethods, ThreadProps } from './Thread';

const ThreadTrace = (props: Omit<ThreadProps, 'headerOpts' | 'rootCommentOps'>) => {
  const help = React.useMemo(
    () => (
      <p>
        Suggest a{' '}
        <a href="https://www.crk.umn.edu/library/primary-secondary-and-tertiary-sources">primary or secondary source</a>{' '}
        that helps people fact-check and spin-check this story.
      </p>
    ),
    [],
  );
  const rootCommentOpts = React.useMemo(
    () => ({
      ezInput: 'link',
      help,
    }),
    [],
  ) as { ezInput: 'link'; help: React.ReactNode };
  const threadRef = React.useRef<ThreadMethods | null>(null);
  const [threadCollapsed, setThreadCollapsed] = React.useState(false);
  const threadRoot = useThreadRoot(props.threadId);
  return (
    <div>
      <SectionHeaderTab
        className={props.showQuickCommentInput ? '!tw-mb-4' : undefined}
        title="Sources"
        titleClassName={threadCollapsed ? 'tw-italic' : undefined}
        titleSuffix={
          threadRoot && cfe.ApiData.hasData(threadRoot) ? (
            <div className="tw-flex tw-items-center">
              <SourceTraceIcon size="1rem" />
              <span className="tw-ml-1">{threadRoot.data.thread.comment_count}</span>
            </div>
          ) : undefined
        }
        round="right"
        right={
          <div className="tw-flex tw-items-center">
            <Button sm className="tw-mr-4" onClick={() => threadRef.current?.showRootCommentForm()}>
              Add Source
            </Button>
          </div>
        }
        onClick={() => {
          setThreadCollapsed(!threadCollapsed);
          if (threadRef.current) {
            threadRef.current.collapse(!threadCollapsed);
          }
        }}
      />
      <div className="tw-mb-2" />
      <div className="kb-pad-4-na">
        <Thread
          {...props}
          key={props.threadId}
          ref={threadRef}
          addRootCommentTitle="Add Source"
          rootCommentOpts={rootCommentOpts}
        />
      </div>
    </div>
  );
};

export default ThreadTrace;
